// SPDX-License-Identifier: AGPL-3.0-or-later

import type {UpdaterMachineEvent} from '@app/features/updater/state/UpdaterStateMachine';

export function getMacUpdaterRecoveryEvent(input: {
	platform?: string | null;
	error: string;
	apiEndpoint: string;
	channel?: string | null;
	arch?: string | null;
	version: string | null;
}): Extract<UpdaterMachineEvent, {type: 'native.available'}> | null {
	if (input.platform !== 'darwin' || !input.error.includes('ENOENT') || !input.error.includes('app-update.yml')) {
		return null;
	}
	const channel = input.channel === 'canary' ? 'canary' : 'stable';
	const arch = input.arch === 'arm64' || input.arch === 'aarch64' ? 'arm64' : 'x64';
	const endpoint = input.apiEndpoint.replace(/\/+$/u, '');
	return {
		type: 'native.available',
		version: input.version,
		downloadSize: null,
		downloadStarted: false,
		downloadUrl: `${endpoint}/dl/desktop/${channel}/darwin/${arch}/latest/dmg`,
		downloadOptions: [],
	};
}
